import { render, staticRenderFns } from "./quoteBasic.vue?vue&type=template&id=3ebed909&"
import script from "./quoteBasic.vue?vue&type=script&lang=js&"
export * from "./quoteBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports